import FeedbackLayer from './ui/FeedbackLayer';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './ui/bootstrap-scoped.css';
import './index.css';
import './app/workspace.css';
import './planning/redesign.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div className={window.location.pathname.startsWith('/display') ? undefined : 'board-app'}><App /><FeedbackLayer /></div>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
